












import { AdgroupConfig, AdgroupFormData } from '@tt4b/ttam-enums';
import { genBuyingTypeOptions } from './const';
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import TtamBuyingType from './buying-type/index.vue';
import { usePropsVisible } from './hooks';

const name = 'ttam-buying-type-compose';
export default defineComponent({
  name,
  components: {
    TtamBuyingType,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, adgroupConfig } = toRefs(props);
    const _classify = computed({
      get: () => adgroupData.value.classify,
      set: val => {
        emit('change', val);
      },
    });
    const disabled = computed(() => adgroupConfig.value.disableClassify);
    const { visible } = usePropsVisible();
    return {
      name,
      _classify,
      disabled,
      visible,
      genBuyingTypeOptions,
    };
  },
});
